module.exports = __webpack_public_path__ + "static/media/aiva_background.c90b1139.png";